import { jsonStringify } from '@ringcentral/rwc-utils/src/lang/json';
import { AbstractTransport } from './abstract-transport';
import '../types';

export class ExternalApiTransport extends AbstractTransport {
    constructor(opts, emit) {
        super(opts);
        this._emit = emit;
    }

    /** @param {LoggerFormattedMessage} message - message formatted by logger */
    log(message) {
        this._emit({
            level: message.lvl,
            prefix: message.prefix,
            timestamp: message.tsz,
            message: jsonStringify(message.parts),
        });
    }
}
